import { getValTerminalByCode } from '../../api/api'

const colorArr = ['#031562', '#D70010', '#046133', '#0172BC', '#E95504', '#A71E32', '#D51719', '#015293','#5883FF']


const state = {
    userInfo: {
        name: 'liuxiaowei',
        old: {},
    },
    config: {
        isSuccessRes:true,
        bannerImg: '',
        inputBgWrapperColor:'#fff',//页面颜色默认值，勿改
        inputBgPic: '', 
        inputBgColor: '#f3f5ff',//页面颜色默认值，勿改
        inputColor: '#969caa',//页面颜色默认值，勿改
        buttonBgColor: '#5883ff',//页面颜色默认值，勿改
        buttonColor: '#fff',//页面颜色默认值，勿改
        // pagePic1:'',
        shareTItle:'',
        shareContent:'',
        sharePic:'',
        bgType:'0',
        ImgArr:[],
        isload:'',
        terminalColor: '#5883ff'//报告配色默认值，勿改
    }
}
const getters = {
    // userName: state => state.useerInfo.name,
    // yearOld: state => state.userInfo.old
};
const mutations = {
    CHANGE_ISLOAD: (state, roles) => {
        state.config.isload = roles
    },
    CHANGE_STYLE: (state, res) => {
        console.log('res',res);

        state.config.isload = 'load'
        if (res.code === "S01" && Number(res.results.associatedProject)===1){
        state.config.bannerImg = res.results.headPicture;
        if (res.results.terminalType===0){
            state.config.inputBgWrapperColor = res.results.backgroundColor;
            state.config.bgType = 0
        }else{
            state.config.inputBgPic = res.results.backgroundImage;
            state.config.bgType = 1
        } 
        state.config.inputBgColor = res.results.inputBoxColor;
        state.config.inputColor = res.results.inputBoxFontColor;
        state.config.buttonBgColor = res.results.buttonColor;
        state.config.buttonColor = res.results.buttonFontColor;
        state.config.ImgArr = res.results.tailPicture?res.results.tailPicture.split(','):[];
        state.config.terminalColor = colorArr[Number(res.results.terminalColor)] || '#5883ff';
        state.config.shareTItle = res.results.terminalShareTitle
        state.config.shareContent = res.results.terminalShareContent
        state.config.sharePic = res.results.shareIcon
        }else{
            state.config.isSuccessRes = false
        }
    }
};
const actions = {
    // changeUserName({ commit }, role) {
    //     return new Promise((resolve) => {
    //         commit('CHANGE_USERNAME', role)
    //         resolve()
    //     })
    // },
    getValTerminalByCode({ commit }, reqData) {
        return new Promise((resolve) => {
            if(reqData.terminalCode){
                getValTerminalByCode(reqData).then(
                    (res) => commit('CHANGE_STYLE', res)
                )
            }else{
                commit('CHANGE_ISLOAD','noSLoad') 
            }
            
        })
    }
}

export default {
    namespaced: true,//解决不同模块的命名冲突问题
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/admin.js